import React from 'react';
import { Form, Header, Segment, Tab, Responsive, Select, Button, Icon } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import StudentGroups from './StudentGroups';
import { fetchAcademicYears, fetchCurrentAcademicYear, fetchGroupTypes } from '../../Lookups/util';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { Link } from 'react-router-dom';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const fetchCourseBasics = () => axios.get('course/basic/false');

export default class TypeCourseAndImplementations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courseBasics: [],
            groupType: '',
            courseBasic: '',
            courseImplementations: [],
            courseImplementation: '',
            groups: [],
            academicYears: [],
            academicYearId: '',
            showGroups: false

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getImplementations = this.getImplementations.bind(this);
        this.getGroups = this.getGroups.bind(this);
    }


    componentDidMount() {
        this.setState({ loader: true });
        if (this.props.location.state !== undefined) {
            if (this.props.location.state.addedGroup === true) {
                toast('Uspješno ste kreirali studentsku grupu!');
            } else if (this.props.location.state.addedGroup === false) {
                toast('Došlo je do greške! Kreiranje studentske grupe nije uspjelo.');
            }
        }

        axios.all([fetchAcademicYears(), fetchCurrentAcademicYear()])
            .then(axios.spread((yearsRes, currentYearRes) => {
                const academicYears = yearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                this.setState({
                    academicYears, academicYearId: localStorage.getItem('academicYearId') ? localStorage.getItem('academicYearId') : currentYearRes.data.id
                });

                if (!localStorage.getItem('academicYearId')) {
                    localStorage.setItem('academicYearId', currentYearRes.data.id);
                }

                localStorage.setItem('currentAcademicYearId', currentYearRes.data.id);
            }))
            .catch(err => {
                console.log('Failed to fetch academic years...');
            });

        axios.all([fetchGroupTypes(), fetchCourseBasics()])
            .then(axios.spread((groupRes, courseRes) => {
                let groupType = '';
                if (this.props.location.pathname === '/ispitne-grupe') { groupType = groupRes.data.find(e => e._key === 'exam').id; }
                if (this.props.location.pathname === '/studentske-grupe') { groupType = groupRes.data.find(e => e._key === 'lecture').id; }

                localStorage.setItem('groupType', groupType);
                if (localStorage.getItem('courseImplementation')) {
                    this.getGroups(
                        groupType,
                        localStorage.getItem('courseImplementation')
                    );
                }

                const courseBasics = courseRes.data.map(el => ({
                    ...el, description: el.comment, key: el.id, value: el.id.toString(), text: el.name
                }));

                this.setState({ courseBasics, groupType });
            }))
            .catch(err => {
                console.log('Failed to fetch data...');
            });

        if (localStorage.getItem('courseBasic') && localStorage.getItem('courseImplementation') && localStorage.getItem('academicYearId')) { this.setState({ showGroups: true }); }


        if (localStorage.getItem('courseBasic')) {
            this.getImplementations(localStorage.getItem('courseBasic'), localStorage.getItem('academicYearId'));
        }
    }

    getGroups(groupType, courseImplementation) {
        let obj = {};
        this.setState({ loader: true });
        axios.post(`course/groups/${courseImplementation}/${groupType}`, { ...obj })
            .then(res => {
                this.setState({ groups: res.data, showGroups: true, loader: false });
            })
            .catch(err => {
                console.log('Failed to fetch groups');
            });
    }


    getImplementations(courseBasic, academicYearId) {
        axios.get(`course/implementations/by-course-basic-and-academic-year/${courseBasic}/${academicYearId}/`)
            .then(res => {
                const courseImplementations = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.comment ? el.semesters[0].name.name + ' ' + el.semesters[0].academicYear.name + ' - ' + el.comment : el.semesters[0].name.name + ' ' + el.semesters[0].academicYear.name
                })).sort((a, b) => b.semesters[0].academicYear.startYear - a.semesters[0].academicYear.startYear);
                this.setState({ courseImplementations });
            })
            .catch(err => {
                console.log('Failed to fetch course basics');
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'academicYearId') {
            this.setState({ courseImplementation: '', showGroups: false });
            this.getImplementations(localStorage.getItem('courseBasic'), value);
            localStorage.setItem('academicYearId', value);
        }
        if (name === 'courseBasic') {
            this.getImplementations(parseInt(value, 10), localStorage.getItem('academicYearId'));
            this.setState({ groups: [], showGroups: false, courseImplementation: '' });
            window.localStorage.removeItem('courseImplementation');
            localStorage.setItem('courseBasic', value);
        }
        this.setState({
            [name]: value
        });

        if (name === 'courseImplementation') {
            this.setState({ groups: [], showGroups: false });
            localStorage.setItem('courseImplementation', value);
            this.getGroups(this.state.groupType, value);
        }
    }


    render() {
        // const panes = [
        //     {
        //         menuItem: 'Aktivne grupe',
        //         render: () => (<Tab.Pane as={Responsive}>
        //             <StudentGroups
        //                 implementationName={this.state.courseImplementations.find(el => el.id === parseInt(localStorage.getItem('courseImplementation'), 10)) ? this.state.courseImplementations.find(el => el.id === parseInt(localStorage.getItem('courseImplementation'))).text : ''}
        //                 data={this.state.groups.filter(el => !el.archived)}
        //                 active
        //                 examGroups={this.props.location.pathname === '/ispitne-grupe'}
        //                 getGroups={(groupType, courseImplementation) => this.getGroups(groupType, courseImplementation)}
        //                 loader={this.state.loader}
        //             /></Tab.Pane>)
        //     },
        //     {
        //         menuItem: 'Arhivirane grupe',
        //         render: () => (<Tab.Pane as={Responsive}><StudentGroups
        //             data={this.state.groups.filter(el => el.archived)}
        //             examGroups={this.props.location.pathname === '/ispitne-grupe'}
        //             getGroups={(groupType, courseImplementation) => this.getGroups(groupType, courseImplementation)}
        //
        //         /></Tab.Pane>)
        //     }
        // ];
        return (
            <div>
                <Header as="h1">{this.props.location.pathname === '/ispitne-grupe' ? 'Ispitne grupe' : 'Studentske grupe'}</Header>

                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">{this.props.location.pathname === '/ispitne-grupe' ? 'Spisak ispitnih grupa' : 'Spisak grupa za predavanja'}
                            <Header style={IconHeader} floated="right">
                                {
                                    !this.props.location.pathname === '/ispitne-grupe' ?
                                        <Link to={{
                                            pathname: '/studentske-grupe/nova-grupa',
                                            state: {
                                                courseImplName: this.state.courseImplementations.find(el => el.id === parseInt(localStorage.getItem('courseImplementation'), 10)) ? this.state.courseImplementations.find(el => el.id === parseInt(localStorage.getItem('courseImplementation'))).text : '',
                                            }
                                        }}
                                        ><br />
                                            <Button
                                                disabled={!localStorage.getItem('courseBasic') || !localStorage.getItem('courseImplementation')}
                                                floated="right"
                                                icon
                                                labelPosition="right"
                                                color="blue"
                                                size="small"
                                                style={FiltersOnStyle}
                                            ><Icon className="add" />
                                                Kreiranje grupe za predavanja
                                            </Button>
                                        </Link>
                                        :
                                        <Link to={{
                                            pathname: '/ispitne-grupe/nova-grupa',
                                            state: {
                                                courseImplName: this.state.courseImplementations.find(el => el.id === parseInt(localStorage.getItem('courseImplementation'), 10)) ? this.state.courseImplementations.find(el => el.id === parseInt(localStorage.getItem('courseImplementation'))).text : '',
                                            }
                                        }}
                                        >
                                            {localStorage.getItem('academicYearId') === localStorage.getItem('currentAcademicYearId') &&
                                            <div>
                                                <Button
                                                    disabled={!localStorage.getItem('courseBasic') || !localStorage.getItem('courseImplementation')}
                                                    floated="right"
                                                    icon
                                                    labelPosition="right"
                                                    color="blue"
                                                    size="small"
                                                    style={FiltersOnStyle}
                                                ><Icon className="add" />
                                                    Kreiranje ispitne grupe
                                                </Button>
                                            </div>}
                                        </Link>
                                }
                            </Header>
                        </Header>
                    </Segment>

                    <Segment clearing>
                        <Form>
                            <Form.Group>
                                <Form.Field
                                    width="4"
                                    required
                                    control={Select}
                                    label="Akademska godina"
                                    placeholder="Odaberite akademsku godinu"
                                    value={localStorage.getItem('academicYearId') ? parseInt(localStorage.getItem('academicYearId'), 10) : this.state.academicYearId}
                                    name="academicYearId"
                                    options={this.state.academicYears}
                                    onChange={this.handleInputChange}
                                />
                                <Form.Field disabled={!this.state.academicYearId} width="8">
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite predmet"
                                        value={localStorage.getItem('courseBasic') ? localStorage.getItem('courseBasic') : this.state.courseBasic}
                                        onChange={this.handleInputChange}
                                        name="courseBasic"
                                        options={this.state.courseBasics}
                                        label="Predmet"
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field disabled={!localStorage.getItem('courseBasic')} width="4">
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite implementaciju predmeta"
                                        value={localStorage.getItem('courseImplementation') ? parseInt(localStorage.getItem('courseImplementation'), 10) : this.state.courseImplementation}
                                        onChange={this.handleInputChange}
                                        name="courseImplementation"
                                        options={this.state.courseImplementations}
                                        label="Implementacija predmeta"
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                            </Form.Group>
                            <br />
                        </Form>

                        {this.state.showGroups &&

                        <StudentGroups
                            implementationName={this.state.courseImplementations.find(el => el.id === parseInt(localStorage.getItem('courseImplementation'), 10)) ? this.state.courseImplementations.find(el => el.id === parseInt(localStorage.getItem('courseImplementation'))).text : ''}
                            data={this.state.groups.filter(el => !el.archived)}
                            active
                            examGroups={this.props.location.pathname === '/ispitne-grupe'}
                            getGroups={(groupType, courseImplementation) => this.getGroups(groupType, courseImplementation)}
                            loader={this.state.loader}
                        />

                        }
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/TypeCourseAndImplementations.js